import exp from "constants";
import { LookupDetailConstants } from "./LookupDetailConstants";

export const CustomerScreenTabs = {
    policies : { key : "policies", text : "POLICIES"},
    policydetail: { key: "policydetail", text: "POLICY DETAILS" },
    tasks : { key : "tasks", text : "TASKS" },
    activity : { key : "activity", text : "ACTIVITY" },
    history : { key : "history", text : "HISTORY" },
    campaigns : { key : "campaigns", text : "CAMPAIGNS" },
    notes : { key : "notes", text : "MEMO" },
    documents : { key : "documents", text : "DOCUMENTS" },
    customer : { key : "customer", text : "CUSTOMER" },
    contacts : { key : "contacts", text : "CONTACTS" },
    losshistory : { key : "losshistory", text : "LOSS HISTORY" },
    mailmerge: { key: "mailmerge", text: "Mail Merge" },
    activityHistory: { key: "activityHistory", text: "Activity History" },
    files : {key: 'files', text: 'FILES'},
    emaildoc: { key: "emaildoc", text: "EMAIL DOCUMENTS"},
};

export const AdminScreenTabs = {
    // general: {key: "general", text: "General", submenus: [
    //     { menuKey: 'lookuptables', menuText: 'Lookup Tables' },
    //     { menuKey: 'zipcodes', menuText: 'Zip Codes' }
    // ]},
    usersetup: {key: "usersetup", text: "User Setup"
        //, submenus: [
        // { menuKey: 'usersetupsub', menuText: 'User Setup'},
        // { menuKey: 'taskusergroup', menuText: 'Task User Group'}
    //]
},
    roleprivilege: {key: "roleprivilege", text: "Role Privilege Setup"},
    security: {key: "security", text: "Security"}//,
//     company: {key: "company", text: "COMPANY", submenus: [
//         { menuKey: 'insurance', menuText: 'Insurance' },
//         { menuKey: 'mortgage', menuText: 'Mortgage'},
//         { menuKey: 'autolosspayee', menuText: 'Auto Loss Payee' },
//         { menuKey: 'priorinsurancecompany', menuText: 'Prior Insurance Company' },
//         { menuKey: "carrier-management", menuText: "Carrier Management" }
//     ]},
//     agency: {key: "agency", text: "AGENCY"
//     //     , submenus: [
//     //     { menuKey: 'agency', menuText: 'Agency'}
//     // ]
// }
}

export const MaintenanceScreenTabs = {
    general: {key: "general", text: "General", submenus: [
        { menuKey: 'lookuptables', menuText: 'Lookup Tables' },
        { menuKey: 'zipcodes', menuText: 'Zip Codes' }
    ]},
    company: {key: "company", text: "Company", submenus: [
        { menuKey: 'insurance', menuText: 'Insurance' },
        { menuKey: 'mortgage', menuText: 'Mortgage'},
        { menuKey: 'autolosspayee', menuText: 'Auto Loss Payee' },
        { menuKey: 'priorinsurancecompany', menuText: 'Prior Insurance Company' },
        { menuKey: "carrier-management", menuText: "Carrier Management" }
    ]},
    agency: {key: "agency", text: "Agency"}
}

export const DATA_IDs = {
    COMPANIES : {
        "Westwood_Insurance_Agency" : "755c7cb4-a38a-4ca0-8758-ebe7c80eb84e"
    },
    COUNTRIES : {
        "USA" : "68a16c92-4427-42f6-a8b0-06f18c60d38a",
        "CANADA" : "930b8763-eb01-4173-ba6f-6bfd646bfded"
    }
};

// shared by standard and advanced customer search screens, which persist/restore the same filter shape
export const CUSTOMER_FILTER_STORAGE_KEY = 'cs2_customer_filter'

export const SUCCESS_MESSAGE='Data submitted successfully.'
export const UPDATE_SUCCESS_MESSAGE='Data updated successfully.'
export const DELETE_SUCCESS_MESSAGE='Data deleted successfully.'
export const QUERY_DELETE_SUCCESS_MESSAGE='Query deleted successfully.'
export const TEMPLATE_DELETE_SUCCESS_MESSAGE='Template deleted successfully.'
export const CAMPAIGN_SEND_TEST_SUCCESS_MESSAGE='Email sent successfully'
export const ERROR_OCCURED="An error occured:"
export const ERROR_MESSAGE='Error occured while submitting the data.'
export const ERROR_MESSAGE_QUERYNAME='Query name is required.'
export const ERROR_MESSAGE_Duplicate='Please update the Query Name.'
export const ERROR_MESSAGE_LOAD='Not able to load data.'
export const ERROR_MESSAGE_SEND_ON_DATE_EMPTY="Send On Date cannot be empty"
export const ERROR_MESSAGE_SEND_ON_DATE_PAST_DATE="Send on Date cannot be in the Past"
export const ERROR_MESSAGE_SEND_ON_DATE_BLACKOUT_DATE="Blackout Date Selected, Select another Date"
export const CAMPAIGN_SEND_TEST_ERROR_MESSAGE='Email failed to send'
export const SEND_TEST_INVALID_EMAIL_FORMAT_WARNING='Invalid Email format, Valid email format(eg: abc12@defg.com)'
export const SAVE_MEMO_SUSSESS='Memo Saved successfully.'
export const UPDATE_MEMO_SUSSESS='Memo updated successfully.'
export const DELETE_MEMO_SUSSESS='Memo Deleted successfully.'
export const UNAUTHORISED_USER='You are not authorised to perform this action.'
export const INACTIVE='Inactive'
export const INACTIVATE='Inactivate'
export const CURRENT_USER='current user'
export const SAVED='Saved'
export const REJECTED= 'Rejected'
export const SENT='Sent'
export const Waiting_Approval='Waiting Approval'
export const APPROVED = 'Approved'
export const CONFIRM_BLACKOUT_DATE_SELECTION ="Date Selected is a Blackout Date, do you want to continue?"
export const CONFIRM_INACTIVE_CAMPAIGN_SELECTION="Campaign is being set to Inactive,this can not be reversed.Do you want to continue?"
export const CONFIRM_CAMPAIGN_DELETION='Are you sure you want to delete the Campaign?'
export const DELETE_CAMPAIGN_SUSSESS='Campaign Deleted successfully.'
export const EMPTY_SELECT ="Field should not be left empty."
export const FIELD_MIN_CHAR ="Field should have more than {} characters."
export const FIELD_MAX_CHAR ="Field should have more than {} characters."
export const VALUE_NOT_CHANGED ="Field value not changed."
export const CAMPAIGN_DASHBOARD_DESCRIPTION ="Current Month and next month campaigns"
export const SELECT_STATUS ="Please select the status."
export const CONFIRM_QUERY_DELETION="Are you sure you want to delete the Query?"
export const CONFIRM_EXIT="Do you want to leave without saving?"
export const CONFIRM_UPDATE = "Do you want to leave without saving?"
export const DESCRIPTION_REQUIRED="Description is required."
export const TYPE_SENDGRID_TEMPLATE="Type/ Sendgrid Template"
export const SELECT_TYPE="Please select the Type."
export const TEMPLATE_TYPE="Select template type."
export const SELECT_SENGRID_TEMPLATE="Select Sendgrid Template"
export const FEEDBACK_SELECT_SENGRID_TEMPLATE="Please select the Sendgrid Template."
export const SELECT_CATEGORY="Please select the Category."
export const CONFIRM_TEMPLATE_DELETION="Are you sure you want to delete the Template?"
export const UNIQUE_QUERY_ERROR="Query Name must be unique"
export const EMPTY_QUERY_ERROR="Query Name should not be left blank."
export const EMPTY_TEMPLATE_ERROR="Template Name should not be left blank."
export const MAX_QUERY_LEN_ERROR="Field require 3 to 150 characters"
export const MAX_TEMPLATE_LEN_ERROR="Field require 3 to 150 characters"
export const MIN_QUERY_LEN_ERROR="Field require 3 to 150 characters"
export const MIN_TEMPLATE_LEN_ERROR="Field require 3 to 150 characters"
export const MIN_DESC_LEN_ERROR="Field require 3 to 250 characters"
export const MAX_DESC_LEN_ERROR="Field require 3 to 250 characters"
export const EMPTY_DESC_ERROR="Description should not be left blank."
export const EMPTY_DB_FIELD_ERROR="Field should not be left blank."
export const EMPTY_LOGIC_FIELD_ERROR="Condition should not be left blank."
export const EMPTY_FRIENDLY_NAME_FIELD_ERROR="Friend name should not be left blank."
export const EMPTY_FIELD_TYPE_FIELD_ERROR="Field type should not be left blank."
export const EMPTY_DATA_TYPE_LOGIC_ERROR="Data type logic should not be left blank."
export const EMPTY_SQL_FIELD_ERROR="Query should not be left blank."
export const MIN_SQL_FIELD_ERROR="Query requires more than 10 characters"
export const EMPTY_STATUS_FIELD_ERROR="Status should not be left blank."
export const FIELD_VALUE_SQL="Dropdown-SQL"
export const FIELD_VALUE_LIST="Dropdown-List"
export const FIELD_VALUE_LIST_INSERT_TEXT="Please enter value separated by ;"
export const FIELD_VALUE_SQL_INSERT_TEXT="Please enter the SQL query"
export const TEMPLATE_TYPE_EMPTY="Type should not be empty."
export const SENDGRID_TEMPLATE_EMPTY="Sendgrid template should not be empty."
export const TEMPLATE_CATEGORY_EMPTY="Category should not be empty."
//export const TEMPLATE_NAME_EXIST="Template name must be unique"
export const SAVE='Save'
export const ACTIVE='Active'
export const SAVE_AS='Save As'
export const TEMPLATE_TYPE_MARKETING='Marketing'
export const TEMPLATE_TYPE_TRANSCTIONAL='Transactional'
export const TEMPLATE_TYPE_ALL='ALL'
export const DEFAULT_ERROR='Something went wrong. Not able to fulfill your request.'
export const CAN_DELETE_TEMPLATE='Template can not be deleted, because it is being used by a Campaign.'
export const UNIQUE_TEMPLATE_NAME='Template Name must be unique'
export const FIELD_BLANK='Field cannot be blank'
export const INVALID_ZIPCODE = 'Invalid Zip Code. Example 12345 or 12345-1234.'
export const ZIPCODE_TOOLTIP = 'Enter Zip Code: 12345 or 12345-1234.'
export const INVALID_DATE_RANGE = 'Invalid date range. Please check your dates.'
export const NO_HISTORY_RECORD_FOUND = 'No History Record found'
export const UNIQUE_CAMPAIGN_ERROR ='Campaign Name must be unique'
export const NAME_LEN_ERROR ='Field require 3 to 150 characters'
export const DESCRIPTION_LEN_ERROR ='Field require 3 to 250 characters'
export const FIELD_INCORRECT='Please select the correct value'
export const SHOW_SCROLL_BUTTON_POSITION=500;
export const SQL='SQL';
export const DEFAULT_GUID='00000000-0000-0000-0000-000000000000'
export const PLEASE_SELECT='--Please Select--'
export const CONFIRM_MEMO_DELETION = "Are you sure you want to delete the Memo?"
export const AUTO_CLOSE=2000;
export const QUERY_SUCCESS_MESSAGE='Query submitted successfully.'
export const QUERY_UPDATE_SUCCESS_MESSAGE='Query updated successfully.'
export const TEMPLATE_SUCCESS_MESSAGE='Template submitted successfully.'
export const TEMPLATE_UPDATE_SUCCESS_MESSAGE='Template updated successfully.'
export const CAMPAIGN_REPORT='Campaign Report'
export const FILTER_CRITERIA_CONSOLIDATED_ERROR='Fix highlighted errors'
export const FILTER_CRITERIA_ZIP_NUMBER_CURRENCY_PLACEHOLDER = 'Only no.s separated by ; allowed'
export const REQUEST_CAMPAIGN_SUCCESS_MESSAGE = 'Campaign Requested and Email has been Sent.'
export const REQUEST_CAMPAIGN_ERROR_MESSAGE = 'Request Campaign Failed'
export const PLACEHOLDER_CURRENCY_RANGE_TO='To Currency Range'
export const PLACEHOLDER_CURRENCY_RANGE_FROM='From Currency Range'
export const PLACEHOLDER_NUMBER_RANGE_TO='To Number Range'
export const PLACEHOLDER_NUMBER_RANGE_FROM='From Number Range'
export const PLACEHOLDER_DATE_RANGE_FROM='From Date mm/dd/yyyy'
export const PLACEHOLDER_DATE_RANGE_TO='To Date mm/dd/yyyy'
export const INACTIVE_QUERY_SELECTED_WARNING='Active query must be selected'
export const INACTIVE_TEMPLATE_SELECTED_WARNING= 'Active template must be selected'
export const ERROR_MESSAGE_CAMPAIGN_FROM_EMAIL_EMPTY="From Email cannot be empty"
export const MAX_YEAR = 2050
export const MAX_DATE = new Date("12/31/2050")
export const LOCAL_TIME_ZONE_TOOLTIP = "Displayed in your local time zone"
export const EST_TIME_ZONE = "-05:00"
export const IST_TIME_ZONE = "+05:30"
export const USER_SETUP_ENTITY_LABEL = " Setup"

//Constant IDs
//3rd Party Template
export const EXTERNAL_TEMPLATE_INACTIVE='0644C9AB-9FEA-4539-8499-FDE607EBCB40'
export const TEMPLATE_TYPE_MARKETING_ID='0A5D4DA6-B452-456C-B19D-700BBEEC2243'
export const TEMPLATE_TYPE_TRANSCTIONAL_ID='F939D9D9-4F8B-4EEA-A178-F2BD3C85D809'
export const STATUS_SAVED='641004B8-3A6E-4731-9070-BF1E50B9DC3C'
export const STATUS_ACTIVE='71DC46A1-5A2A-422F-963A-78BBF78A263E'
export const STATUS_INACTIVE='1CCA1674-9F92-44CE-B8E0-AA1DED814BDF'

//Queries
export const QUERY_STATUS_SAVED='03E80277-7096-465C-B0CA-CEBC807ED9A7'
export const QUERY_STATUS_ACTIVE='9DC70078-3FAD-4E30-BDC8-F7718AC98765'
export const QUERY_STATUS_INACTIVE='0644C9AB-9FEA-4539-8499-FDE607EBCB40'
export const DROPDOWN_SQL_ID='5aeadd77-0a24-4219-910d-15e406e1bd08'
export const DROPDOWN_LIST_ID='1e9adae2-fbf1-42d9-bf6b-de1af266e60c'
export const EMPTY_DB_SERVER_ERROR="Database Server should not be left blank."

// //Campaign Filter Data Type Ids

export const Data_Type_Dropdown_SQL="5aeadd77-0a24-4219-910d-15e406e1bd08"
export const Data_Type_ZipCode="ff729d37-63f0-4aa6-9af2-457871867254"
export const Data_Type_Currency_Range="47994ac7-5453-42d6-84d3-73f2ab13d325"
export const Data_Type_Number_Range="63bad727-bce0-48b7-9932-779003362140"
export const Data_Type_Currency="ecc27e57-ceb1-4ef3-ab56-7797b08be47e"
export const Data_Type_Date_Range="9dcc86f9-e74a-4e0b-a620-79cc42b9c05d"
export const Data_Type_Date="0d269253-5fdf-42c0-8ded-dd58a220c3e2"
export const Data_Type_Dropdown_List="1e9adae2-fbf1-42d9-bf6b-de1af266e60c"
export const Data_Type_Number="89c5122c-b3d5-478b-910f-f47608204f41"
export const DATA_TYPE_FREEFORM="dde2fd39-2313-4114-ba7d-04beb993ffd9"

// Customer Policy Default Source
export const DEFAULT_SOURCE_ID = "2f5fc8a3-66b9-4673-a904-7599b9ab0e43"

// Customer Module
export const CUSTOMER_NOT_FOUND = "Customer not found."
// Customer Policies List.
export const CUSTOMER_POLICY_LIST_ERROR_WHILE_FETCHING_POLICIES ='We encountered an issue while fetching customer policies. Please try again in a moment. If the problem persists, contact support team for assistance.'
export const CUSTOMER_MAIN_PORTAL_INITIALIZE_ERROR ='We encountered an issue while initializing customer main view. Please try again in a moment. If the problem persists, contact support team for assistance.'
// Customer Standard Search.
export const CUSTOMER_STANDARD_SEARCH_ERROR_WHILE_SEARCHING ='We encountered an issue searching for customers with given filters. Please try again in a moment. If the problem persists, contact support team for assistance.'
export const CUSTOMER_STANDARD_SEARCH_NO_RESULT_FOUND =`We couldn't find any customers matching the search criteria. Please adjust your search filters and try again.`
export const CUSTOMER_STANDARD_SEARCH_PARTIAL_DATA =`Only the first 500 displayed, Refine search for less options`
export const CUSTOMER_DETAIL_ERROR_WHILE_LOADING_INITIAL_DATA ='We encountered an issue while fetching customer details. Please try again in a moment. If the problem persists, contact support team for assistance.'
export const CONFIRM_DEPENDENT_DELETE="Are you sure to remove dependent?"
export const CONFIRM_CONTACT_DELETE="Are you sure to remove contact?"
export const CUSTOMER_SAVED_SUCCESSFULLY="Customer information saved successfully.";
export const CUSTOMER_FORM_VALIDATION_ERROR_MESSAGE = "There are few errors in page. Please check the highlighted inputs.";
export const CUSTOMER_SPECIFY_CUSTOMER_DETAILS = "Please specify customer details.";
export const CUSTOMER_MANDATORY_FIELDS_ERROR = "Either First or Last Name or Display name must be entered";
export const CUSTOMER_MANDATORY_DEPEDENT_FIELDS_ERROR = "Either First or Last name must be entered";
export const CUSTOMER_FIRST_NAME_MIN_LENGTH = "Field require 2 to 60 characters";
export const CUSTOMER_LAST_NAME_MIN_LENGTH = "Field require 2 to 60 characters";
export const CUSTOMER_LEGACY_EMP_CODE_MIN_LENGTH = "Field require 3 characters";
export const CUSTOMER_DISPLAY_NAME_MIN_LENGTH = "Field require 2 to 100 characters";
export const CUSTOMER_INVALID_EMAIL = "Specify a valid email";
export const CUSTOMER_AGENCY_MANDATORY = "Field cannot be blank";
export const CUSTOMER_YEAR_EMPLOYED_NUMERIC = "Year employed must be numeric";
export const CUSTOMER_YEAR_EMPLOYED_RANGE = "Year employed cannot be less than 1990";
export const CUSTOMER_ADDRESS1_MIN_LENGTH = "Field require 2 to 100 characters";
export const CUSTOMER_CITY_MIN_LENGTH = "Field require 2 to 100 characters";
export const CUSTOMER_ZIP_MIN_LENGTH = "Field require 5 to 9 characters";
export const CUSTOMER_NON_USA_ZIP_MIN_LENGTH = "Field require 2 to 9 characters";
export const CONTACT_NO_RANGE = "Field require 10 digits";
export const POLICY_EDIT_VALIDATION_ERROR_MESSAGE = "Some errors were found on the page. Please review the highlighted fields.";
export const UNDERWRITING_VALIDATION_ERRORS = "Please resolve the following errors in the Underwriting section:";
export const DUPLICATE_VALUE = "The values in these two fields must be different";
export const CUSTOMER_INCEPTION_DATE_FIELDS_ERROR = "Inception date must be on or before the earliest in-force transaction effective date.";

export const CUSTOMER_DELETE_ERROR = "We encountered an issue while deleting customer. Please try again in a moment. If the problem persists, contact support team for assistance.";
export const CUSTOMER_DELETE_ACTIVE_POLICIES = "Cannot delete customer: Active policies must be Canceled or Expired first.";
export const CUSTOMER_DELETE_INACIVE_POLICY_IN_LAST_ONE_YEAR = "Cannot delete customer: Policies canceled or expired within the last 12 months.";
export const CUSTOMER_DELETE_ACTIVE_TASK = "Cannot delete customer: All open tasks must be completed first.";
export const CUSTOMER_DELETE_SUCCESS = "The customer has been deleted.";
export const CUSTOMER_UPDATE_BUTTON_SUCCESS = "Data has been successfully updated.";
export const CUSTOMER_DELETE_CONFIRM = "Are you sure to delete customer?";
export const CUSTOMER_DELETE_CONFIRM_TITLE = "Delete Customer";
export const CUSTOMER_DELETE_CONFIRM_TEXT = "Enter DELETE here to confirm";
export const CUSTOMER_DELETE_CONFIRMATION_TEXT = "DELETE";
export const CUSTOMER_DELETE_INCOMPLETE_TASKS_RESPONSE = "INCOMPLETE_TASKS";
export const CUSTOMER_DELETE_ACTIVE_POLICIES_RESPONSE = "ACTIVE_POLICIES";
export const CUSTOMER_DELETE_INACTIVE_POLICIES_IN_LAST_ONE_YEAR_RESPONSE = "INACTIVE_POLICIES_IN_LAST_ONE_YEAR";
export const CUSTOMER_DELETE_ACTIVITY_EXISTS = "CUSTOMER_ACTIVITY_EXISTS";
export const CUSTOMER_DELETE_ACTIVITY_EXISTS_MESSAGE = "Customer cannot be deleted as there are associated Activity(ies).";
export const ACTIVITY_DESCRIPITON_MAX_WARNING = "⚠️ Content too long: You've exceeded the character limit. Please shorten the text or attach as a PDF in Documate."
export const SOURCE_BLANK_ERR = "Field cannot be blank when source type is selected";
export const UPDATED_TRANS = "Updated Transaction";


//Employee and User in Admin
export const ADMIN_EMPLOYEE_MANDATORY = "Field cannot be blank"
export const ADMIN_EMPLOYEE_COUNTRYCODE = "Only two characters allowed"


export const FIELD_CANNOT_BE_BLANK = "Field cannot be blank";
export const AGENCY_GROUP_SAVING = "Do you want save the Group Name?";
export const AGENCY_GROUP_UPDATE = "Do you want update the Group Name?";
export const AGENCY_GROUP_SAVING_SUCCESS = "Group Name saved successfully";
export const AGENCY_GROUP_DELETE_SUCCESS = "Group Name Successfully deleted";
export const AGENCY_GROUP_SAVING_ERROR = "Unable to save the Group Name";
export const AGENCY_GROUP_DELETE = "Are sure you want to delete the Agency group: ";
export const AGENCY_GROUP_DELETE_ERROR = "Unable to delete group name";

export const CUSTOMER_ERROR_WHILE_SAVING="We encountered an issue while saving customer information. Please try again in a moment. If the problem persists, contact support team for assistance.";

export const SliderContactConstants = {
    NO_CHANGES_TO_SAVE : "No changes have been made."
}

export const CustomerPolicy = {
    UNKNOWN : "UNKNOWN"
}

export const AcivityPageConstants = {
    ERROR_WHILE_INITIALIZING_DASHBOARD : "We encountered an issue while loading page. Please try again in a moment. If the problem persists, contact support team for assistance.",
}

export const SliderActivityConstant = {
    ARE_YOU_SURE_TO_EXIT: "Do you want to save your changes before leaving?",
    ERROR_WHILE_LOADING_ACTIVITY_PAGE : "We encountered an issue while loading page. Please try again in a moment. If the problem persists, contact support team for assistance.",
    FORM_VALIDATION_ERROR_MESSAGE : "There are few errors in page. Please check the highlighted inputs.",
    ACTIVITY_SAVED_SUCCESSFULLY : "Acivity saved successfully.",
    ERROR_WHILE_SAVING_ACTIVITY : "We encountered an issue while saving activity. Please try again in a moment. If the problem persists, contact support team for assistance.",
    DATE_CAN_NOT_BE_A_FUTURE_DATE : "Date & time cannot be in future"
}

export const CustomerTaskConstants = {
    ERROR_WHILE_LOADING_TASK_GRID_PAGE : "We encountered an issue while loading page. Please try again in a moment. If the problem persists, contact support team for assistance.",
    ERROR_WHILE_LOADING_TASK_LIST : "We encountered an issue while fetching tasks. Please try again in a moment. If the problem persists, contact support team for assistance.",
    ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT : "We encountered an issue while loading page. Please try again in a moment. If the problem persists, contact support team for assistance.",
    ARE_YOU_SURE_TO_EXIT: "Do you want to save your changes before leaving?",
    FORM_VALIDATION_ERROR_MESSAGE : "There are few errors in page. Please check the highlighted inputs.",
    INVALID_TASK_DATE :"Invalid task Date",
    TASK_SAVED_SUCCESSFULLY : "Task saved successfully.",
    NO_HISTORY_AVAILABLE : "No history available",
    TASK_DIALOG_TITLE : "Task History",
    CUSTOMER_DELETED : "CUSTOMER_IS_DELETED",
    ERROR_WHILE_FETCHGIN_TASK_HISTORY : "We encountered an issue while fetching task history. Please try again in a moment. If the problem persists, contact support team for assistance."
}

export const APP_IDs = {
    CS2_APP_ID : '549CD2E9-2A3E-4E18-B23E-4AADA2A5A79C'
};

export const CustomerLossHistoryConstant = {
    ADD_LOSS : "ADD LOSS",
    PLEASE_SELECT : "Please Select",
    COMPANY_COLUMN_HEADER : "Company",
    DATE_OF_LOSS_COLUMN_HEADER : "Date of Loss",
    STATUS_COLUMN_HEADER : "Status",
    KIND_OF_LOSS_COLUMN_HEADER : "Kind of Loss",
    LOSS_HISTORY_DELETE_CONFIRMATION : "Are you sure to remove this loss history record?",
    ERROR_OCCURED_WHILE_FETCHING_LOSS_HISTORY : "We encountered an issue while fetching customer loss history. Please try again in a moment. If the problem persists, contact support team for assistance.",
    ERROR_OCCURED_WHILE_INIT_COMPONENT : "We encountered an issue while loading customer loss history. Please try again in a moment. If the problem persists, contact support team for assistance.",
    DETAIL_REQURIED : "Customer loss history details are required.",
    FIELD_CANNOT_BE_BLANK : "Field cannot be blank",
    FORM_VALIDATION_ERROR_MESSAGE : "There are few errors in page. Please check the highlighted inputs.",
    SAVE_CUSTOMER_LOSS_ERROR_MESSAGE: "We encountered an issue while saving customer loss record. Please try again in a moment. If the problem persists, contact support team for assistance.",
    DELETE_CUSTOMER_LOSS_ERROR_MESSAGE: "We encountered an issue while removing customer loss record. Please try again in a moment. If the problem persists, contact support team for assistance.",
    SAVE_CUSTOMER_LOSS_SUCCESS : "Loss history record save successfully.",
    ARE_YOU_SURE_TO_EXIST : "Do you want to leave without saving?"
}

export const CustomerNotesConstant =
{
    BLANK_DESCRIPTION : "Field cannot be blank",
    INVALID_MEMO_DATE : "Invalid memo Date",
    DISCRIPTION_LENGTH : "Field require 3 to 2000 characters",
    NOTE_UPDATE_ERROR : "We encountered an issue while submitting data.",
    MEMO_SUCCESS_MESSAGE : "Memo Submitted successfuly.",
    NOTE_DATE_EMPTY : "Field cannot be blank",
    FORM_VALIDATION_ERROR_MESSAGE : "There are few errors in page. Please check the highlighted inputs.",
    ARE_YOU_SURE_TO_EXIT: "Do you want to leave without saving?"
}

export const CustomerCampaignConstant = {
    ERROR_WHILE_INITIALIZING_VIEW: "Error while initializing customer campaign view."
};

export const policyStatusColorMap = {
    1 : '#3B8E00',    // Active, Renewed, Rewritten
    2 : '#DC3300',    // Expired, Cancelled, Not Taken
    3 : '#004C97',    // Quote
    100 : '#E0E1E1'   // Others
}

export const policyStatusMap = {
    [LookupDetailConstants.POLICY_STATUS.ACTIVE] : { backgroundColor : policyStatusColorMap[1]},
    [LookupDetailConstants.POLICY_STATUS.CANCELLED] : { backgroundColor : policyStatusColorMap[2]},
    [LookupDetailConstants.POLICY_STATUS.EXPIRED] : { backgroundColor : policyStatusColorMap[2]},
    [LookupDetailConstants.POLICY_STATUS.INCLUDE] : { backgroundColor : policyStatusColorMap[100] },
    [LookupDetailConstants.POLICY_STATUS.NON_RENEWED] : { backgroundColor : policyStatusColorMap[100]},
    [LookupDetailConstants.POLICY_STATUS.NOT_TAKEN] : { backgroundColor : policyStatusColorMap[2]},
    [LookupDetailConstants.POLICY_STATUS.QUOTE] : { backgroundColor : policyStatusColorMap[3]},
    [LookupDetailConstants.POLICY_STATUS.RENEWED] : { backgroundColor : policyStatusColorMap[1]},
    [LookupDetailConstants.POLICY_STATUS.REWRITTEN] : { backgroundColor : policyStatusColorMap[1]},
};

export const SlicerLookUpConstant =
{
    MARITAL_STATUS :"Marital Status",
    OCCUPATION : "Occupation",
    INDUSTRY : "Industry",
    RELATIONSHIP : "Relationship",
    AGENCY : "Agency",
    CLAIMS_STATUS :"Claim Status",
    LOSS_TYPE :"Loss Type",
    ACTIVITY_TYPE :"Activity Type",
    TASK_PRIORITY :"TaskPriority",
    TASK_STATUS :"TaskStatus",
    EMPLOYEE_LIST :"EmployeeList",
    COMPANY_LIST :"CompanyList",
    STATE : "State",
    COUNTRY: "Country",
    US_STATE: " US State",
    CANADA_STATE: "Canada State",
    GENDER_STATE: "Gender",
    INDIVIDUALIZED: "Individualized",
    POLICY_TERM_STATUS: "Policy Term Status",
    POLICY_TYPE: "Policy Type",
    POLICY_BUSINESS_TYPE: "Policy Business Type",
    POLICY_PAYMENT_PLAN: "Policy Payment Plan",
    ATTACH_TYPE: "Attach Type",
    Transaction_Type: "Transaction Type",
    Line_Of_Business: "Line Of Business",
    Source_Type: "Source Type",
    Source_Type_Lookup_Value: "Source Type Lookup Value",
    OCCUPANCY_TYPE: "Occupancy Type",
    RESIDENCE_TYPE: "Residence Type",
    CONSTRUCTION_TYPE: "Construction Type",
    ROOF_MATERIAL_TYPE: "Roof Material Type",
    HEAT_TYPE: "Heat Type",
    SPRINKLER_TYPE: "Sprinkler Type",
    DWELLING_CONDITION_TYPE: "Dwelling Condition Type",
    STORM_SHUTTER_TYPE: "Storm Shutter Type",
    DWELLING_LOC_TYPE: "Dwelling Loc Type",
    SECONDARY_HEAT_TYPE: "Secondary Heat Type",
    FOUNDATION_TYPE: "Foundation Type",
    Cancellation_Reason: "Cancellation Reason",
    DEDUCTIBLE_TYPES: "Deductible Types",
    TRANSACTION_TYPE: "Transaction Type",
    PARENT_COMPANIES: "Parent Companies",
    WRITING_COMPANIES: "Writing Companies",
    LOB_APPLICATIONS: "LOB Applications",
    FORM_TYPE: "Form Type",
    RUN_FREQUENCY_TYPE: "Run Frequency Type",
    BASEMENT_TYPE: "Basement Type",
    NUMBER_OF_FLOORS_TYPE: "Number Of Floors Type",
    CONTENT_LOCATION_TYPE: "Content Location Type",
    RATING_TYPE: "Rating Type",
    NEAREST_SHORE_TYPE: "Nearest Shore Type",
    ELEVATED_FOUNDATION_TYPE: "Elevated Foundation Type",
    ELEVATED_MATERIAL_TYPE: "Elevated Material Type",
    ENCLOSED_FOR_OTHER_PURPOSE_TYPE: "Enclosed For Other Purpose Type",
    FLOOD_OCCUPANCY_TYPE: "Flood Occupancy Type",
    PROTECTION_DEVICE_TYPE: "Protection Device Type",
    INTEREST_TYPE: "Interest Type"
}
 export const CompanyContact ={
    COMPANY_CONATCT : "Company Contact",
    BLANK_FIELD : "Field cannot be blank",
    NAME_LENGTH_RANGE : "Field require 2 to 75 characters",
    TITLE_LENGTH_RANGE : "Field require 2 to 20 characters",
    WORK_PHONE_RANGE: "Field require 10 digits",
    INVALID_ZIPCODE : 'Invalid Zip Code. Example 12345 or 12345-1234.',
    ZIP_RANGE : "Field require 5 to 9 characters"
 }

 export const RolePrivilege = 
 {
     ROLE_SAVED_SUCCESSFULLY : "Role information saved successfully.",
     ROLE_VALIDATION_ERROR_MESSAGE : "There are few errors in page. Please check the highlighted inputs.",
     ROLE_ERROR_WHILE_SAVING : "We encountered an issue while saving role information. Please try again in a moment. If the problem persists, contact support team for assistance.",
     DELETE_ELEMENT_ROW: "Are you sure you want to delete Special Privilege?",
     DELETE_PRIVIELGE_GRID: "Are you sure you want to delete Screen Privilege and it's respective Special Privilege(s) if any?",
     GRID_DELETED_SUCCESS_MESSAGE :"Grid cleared successfully"
}

export const AgencyDetail = {
    DELETE_PRIVIELGE_GRID: "Are you sure you want to delete agency?",
}

export const ScreenName = {
    CAMPAIGN: "Campaign",
    NOTE: "Memo",
    HISTORY: "History",
    CS2_Main_Menu: 'CS2 Main Menu',
    Campaign_Query: 'Campaign Query',
    Campaign_Calendar: 'Campaign Calendar',
    CAMAPIGN_TEMAPLATE: 'Campaign Template',
    CAMPAIGN_APPROVAL: 'Campaign Approval',
    CUSTOMER: 'Customer',
    CUSTOMER_TASK: 'Customer Task',
    CUSTOMER_HISTORY: 'Customer History',
    CUSTOMER_ACTIVITY: 'Customer Activity',
    CUSTOMER_CAMPAIGNS: 'Customer Campaigns',
    CUSTOMER_LOSS_HISTORY: 'Customer Loss History',
    CUSTOMER_DOCUMENT: 'Customer Document',
    CUSTOMER_VIP: "VIP Security",
    POLICY: 'Policy',
    FILE:'Assignments'
}

 export const CustomerScreenName={
    CUSTOMER_NOTES: 'Customer Memo'
 }

 export const CampaignPrivileges={
    SAVE_AS:'Save As',
    INACTIVE: 'Inactive',
    RESULT:'Results',
    CREATE:'Create'
 }

 export const SidebarPrivileges={
    Admin_Management: 'Admin Management',
    Maintenance_Management: 'Maintenance Management',
    Campaign_Management: 'Campaign Management',
    Customer_Management: 'Customer Management',
    Documate_Scan: 'Documate Scan',
    Documate_Indexing: 'Documate Indexing',
    Documate_Search : 'Documate Search',
    Documate_Refi: 'Documate Refi',
    Documate_RecycleBin: 'Recycle Bin',
    Documate_AdminDocument: 'Documate Admin Documents',
    Files: 'Assignments',
    Accounting: 'Accounting'
 }

 export const QueryPrivileges={
    SAVE_AS:'Save As',
    ADD_RULE:'Add Rule',
    STATUS: 'Status',
    TEST_QUERY: 'Test Query'
 }

 export const CampaignCalendarPrivileges={
    CAMPAIGN_INTERACTION: 'Campaign Interaction'
 }

 export const TemplatePrivileges={
    SAVE_AS:'Save As',
    STATUS: 'Status',
 }

 export const ApprovalPrivileges={
    SEND_TEST: 'Send Test',
    APPROVE: 'Approve',
    REJECT: 'Reject'
 }

 export const CustomerDocumentPrivileges={
    UPLOAD: 'Upload',
    DELETE: 'Delete'
 }

  export const CustomerActivityPrivileges={
    EXPORT: 'Export'
 }

//documate constants
export const Documate={
    UnAssignedFolderID: '0FC85543-385F-4314-8C12-BC951C64C504',
    RescanFolderID: 'BF52A1F7-FFC3-459D-BA6B-C19BBE657366',
    RescanGroupsID: 'A07CA396-1830-4973-B066-4FEB1A18CFAB',
    CS2AppId: 102,
    ReleaseSuccessMessage:'Document(s) Successfully Released.',
    ReleaseErrorMessage:'Error while releasing the document(s).',
    IndexSuccessMessage:' Document Successfully Indexed.'
}

export const CustomerPolicyDetailLinks={
    BASIC_COVERAGE: 'BasicCoverage',
    ENDORSEMENTS: 'Endorsements',
    UNDERWRITING: 'Underwriting',
    TRANSACTIONS : 'Transactions',
    LOBS_LOCATIONS : 'LOBs&Locations',
    ADDITIONAL_INTERESTS: 'Additional Interests',
    FLOOD_COVERAGE: 'Flood Coverage'
 }

 //Unmatched Policy Constant
 export const UnMatchedPolicy={
    ERROR_WHILE_FETCHING_CARRIER_MAPPING_LIST:'We encountered an issue while fetching mapping data for carrier. Please try again in a moment. If the problem persists, contact support team for assistance.',
    tab1: 'tab1',
    tab2: 'tab2',
    UI_COMPONENT:'Assignments - UI Component',
 }
 
export const AdminSubject = 'Admin Management';
export const AdminScreenPrivileges = {
    User_Setup: 'User Setup',
    Role_Privilege_Setup: 'Role Privilege Setup',
    Security: 'Security'
}

export const MaintenanceSubject = 'Maintenance Management';
export const MaintenanceScreenPrivileges = {
    Carrier_Management: 'Carrier Management',
    Agency_Setup: 'Agency Setup',
    General: 'General',
    Company: 'Company',
    Lookup_Tables: 'Lookup Tables',
    Zip_Codes: 'Zip Codes',
    Insurance: 'Insurance',
    Mortgage: 'Mortgage',
    Auto_Loss_Payee: 'Auto Loss Payee',
    Prior_Insurance_Company: 'Prior Insurance Company'
}

export const AccountingSubject = 'Accounting';
export const AccountingScreenPrivileges = {
    Reconcile: 'Reconcile',
    Compensation_Rate: 'Compensation Rate',
    History: 'History'
}

export const ADMIN_HISTORY_ACCESS_GROUP = "Admin User and Role Privilege Setup Group";
export const RolePrivilegeSetup={
     ROLE_SETUP_HISTORY: 'Role Privilege Setup History'
}

export const UserSetup={
   ERROR_EMPLOYEE_FETCH_DETAILS :'We encountered an issue while fetching employee/user details. Please try again in a moment. If the problem persists, contact support team for assistance.',
   ERROR_FETCH_OBJECT_ID :'We encountered an issue while fetching object id. Please try again in a moment. If the problem persists, contact support team for assistance.',
   USER_SETUP_HISTORY:'User Setup History',
   EMPLOYEE_SETUP_HISTORY:'Employee Setup History',  
}

export const PolicySummaryErrorMessages = {
    NO_TRANSACTION_FOUND : 'No Transaction found',
    NO_LOCATION_FOUND : 'No Location found',
    NO_COVERAGE_FOUND : 'No Coverage found',
    NO_ENDORSEMENT_FOUND : 'No Endorsement found',
    NO_ADDITIONAL_INTERESTS_FOUND : 'No Additional Interests found',
    NO_UNDERWRITING_FOUND : 'No Underwriting found',
}

export const policyStatusOnDocumentTab = [
      "Active", "Renewed", "Rewritten", "Include", "Quote", 
      "Cancelled", "Expired", "Non-Renewed", "Not taken"
  ];

  export const policyTypeOrderOnDocumentTab = {
    "1685282C-8E32-4257-829D-53071B2AEB05": 1, // HO1
    "1A3ABD3B-B3CD-4930-AF21-1C6DA9D396ED": 1, // HO2
    "82D76C62-7A67-400D-BA5E-BAA8A92D50C5": 1, // HO3
    "3503888C-E0E9-4A63-A078-498F1E9A5ECD": 1, // HO4
    "82D76C62-7A67-400D-BA5E-BAA8A92D50C6": 1, // HO5
    "9634BA6C-A26A-4823-B92F-9786E95BF1DD": 1, // HO6
    "B58FB492-E333-4C62-8FD0-0C3F1A6A40AB": 1, // HO7
    "8C66092E-7218-41B2-9418-BC9191948D04": 1, // HO8
    "75593E27-29AC-4E41-9823-993727E803FD": 1, // HOA
    "BC0A07AD-5798-4D59-88C3-BA61E706BA7A": 1, // HOB - Condo
    "16D44CD6-C9B0-4611-80E7-E147D2D4E4D0": 1, // HOB - Homeowners
    "37542780-5680-40D8-8804-06AD9998EDCE": 1, // HOB - Renters
    "6AE8EE6F-51EB-4543-9EED-8182C63A5237": 1, // HOC - Condo
    "3157EDA9-802A-4BA8-A7D8-117A9C625A91": 1, // HOC - Homeowners
    "DF9FE8B3-D0BA-415F-9F83-22F7EB2B95FF": 1, // HOC - Renters
    "EBED4427-84F5-4679-945A-28C500601A0F": 2, // Private Passenger Auto
    "13173DD0-08DA-4B7C-9835-A773AFB01E32": 3, // Flood
    "C511232A-EF18-4148-B9FD-E52FECD1DED3": 4  // Earthquake (P)
};

export const CustomerPolicyDetails = {
    POLICY_UPDATE_SUCCESSFULLY: "Policy info updated successfully.",
    NO_POLICY_TO_SAVE :"No policy to save.",
    POLICY_ERROR_WHILE_SAVING : "We encountered an issue while saving policy information. Please try again in a moment. If the problem persists, contact support team for assistance.",
    POLICY_NOT_FOUND : "Policy not found.",
    DELETE_ADDITIONAL_INTEREST: "Are you sure you want to delete this additional interest?",
    DELETE_VEHICLE: "Are you sure you want to delete this vehicle?",
    NO_LOCATION_SELECTED: "No location selected.",
    LOCATION_NOT_SAVED: "Please save the location before adding underwriting information.",
    LOCATION_HAS_ADDITIONAL_INTERESTS: "This Policy Location cannot be deleted because it is associated with one or more Additional Interest records. Please remove the associated Additional Interest records before deleting the location.",
}

export const CS2_AttachTypes = {
    LOCATION : '2d49d5ed-92fe-48e9-b226-dfea76438cda',
    LINE_OF_BUSINESS : '048f56c9-e2be-4cef-94cc-c3b886752da7',
}


export const ApplyPolicy = {
ErrorMessage : "Failed to apply policy due to error.",
TitleApplyTransaction : "Apply Transaction",
}

export const policyActionSummaryConstant={    
    NBSTransactionId : '3d1253e2-a34d-4b3d-a191-b6b8744a79ac',
    RewriteTransactionId : 'f2be9e34-5913-460f-8754-42645d3fcf35',
    RenewTransactionId : '4f9dc8bf-eb4d-4f5f-b1cb-9c13b8692c5a',
    CancellationRequestTransId : '4bee9bca-873f-459a-bb80-df08d1c8c00b',
    CancellationConfirmationTransId : 'c811eacf-5d54-4ee9-a71d-5b0800362d09',
    PolicyChangeTransId : 'c77dbb50-cfdf-4085-81b6-3fa580f20d71',
    Personal_Lines_businessTypeId:'706b6685-c60b-4f53-ace5-77fcfc027a7a',
    HomeOwner_LobId: 'be2b23b2-1bae-4c7e-8933-87627dfc89a1', 
    Customer_Policy_Action_MANDATORY: "Field cannot be blank",
    PolicyNumber_MinLength: "Policy Number require min 2 character(s)" ,
    Renew_Rewrite_Confirmation_Popup_MSG: "Selected policy term is not the latest. Proceed with ",
    Customer_Policy_Action_DATE_RANGE_INVALID: "Invalid Expiration Date",
    NewModalTitle: "Creating New Policy for ",
    NewModalEffectiveDateWarning: "Note: Once saved, the Effective Date cannot be changed.",
    DuplicateTermOnRenewValidationErrror : "This term already exists and cannot be created again"
};

export const EventTransactionType={
    NBS: 'NBS',
    REW: 'REW',
    RWL: 'RWL',
    XLC: 'XLC',
    PCH: 'PCH',
    XLN : 'XLN',
    DEL: 'DLT',
};

export const EventTransactionNote={
    NBS: 'New Policy Creation',
    REW: 'Policy Rewrite',
    RWL: 'Policy Renew',
    NBS_NEW_POLICY: 'New Business',
};

export const policyActionConstant={
    NEW: 'new',
    REWRITE: 'rewrite',
    RENEW: 'renew',
    CANCELLATION: 'cancellation',
    ENDORSE: 'endorse',
    COMPARE: 'compare',
    MOVE: 'move',
    DELETE: 'delete'
};

// Map of action -> transaction labels that should be disabled (greyed out) for that action
export const disabledTransactionsByAction: Record<string, string[]> = {
    [policyActionConstant.NEW]: ['anniversary re-rate','assignment','binder endorsement','binder renewal',
                                'cancellation confirmation','cancellation request','non-renewal notified agency',
                                'Non-renewal Notified Polholder','policy change','policy change quote','premium audit',
                                 'reinstatement','reissue','renewal quote','renewal requote','renewal request',
                                'reversal of non-renewal', 'rewrite', 'Policy (unspecified)'],
    [policyActionConstant.ENDORSE]:['Anniversary Re-rate','Binder New Business','Binder Renewal','Cancellation Confirmation','Cancellation Request','New Business',
                                    'New Business Quote','Non-renewal Notified Agency','Non-renewal Notified Policyholder','Renew Policy','Renewal Quote','Renewal Requote',
                                    'Renewal Request','Reversal of Non-renewal','Rewrite'],
    [policyActionConstant.RENEW]:['Assignment','Binder Billable','Binder Endorsement','Binder New Business','Cancellation Confirmation','Cancellation Request',
                                'New Business', 'New Business Quote','Policy Change','Policy Change Quote','Premium Audit','Reinstatement','Reissue',
                                'Rewrite','Policy (unspecified)'],
    [policyActionConstant.REWRITE]:['Assignment','Binder Endorsement','Binder New Business','Binder Renewal','Cancellation Confirmation','Cancellation Request','New Business',
                                    'New Business Quote','Non-renewal Notified Agency','Non-renewal Notified Polholder','Non-renewal Notified Policyholder','Policy Change','Policy Change Quote','Premium Audit',
                                    'Reinstatement','Reissue','Renew Policy','Renewal Quote','Renewal Requote','Renewal Request','Reversal of Non-renewal','Policy (unspecified)'],
    [policyActionConstant.CANCELLATION]:['Anniversary Re-rate','Assignment','Binder Billable','Binder Endorsement','Binder New Business','Binder Renewal','New Business',
                                        'New Business Quote','Non-renewal Notified Agency','Non-renewal Notified Polholder','Non-renewal Notified Policyholder','Policy Change','Policy Change Quote','Premium Audit',
                                        'Reissue','Renew Policy','Renewal Quote','Renewal Requote','Renewal Request','Reversal of Non-renewal','Rewrite'
    ],
};

// Map of action -> transaction labels that are allowed (normal, no highlight) for that action
// Any transaction NOT in disabled or allowed list will be auto-flagged as warning (red highlighted)
export const allowedTransactionsByAction: Record<string, string[]> = {
    [policyActionConstant.NEW]: ['Binder New Business', 'New Business', 'New Business Quote','renew policy' ],
    [policyActionConstant.ENDORSE]: ['Assignment','Binder Endorsement','Policy Change','Policy Change Quote','Reinstatement','Reissue'],
    [policyActionConstant.RENEW]:['Anniversary Re-rate', 'Binder Renewal','Non-renewal Notified Agency','Non-renewal Notified Polholder','Non-renewal Notified Policyholder','Renew Policy','Renewal Quote',
                                'Renewal Requote','Renewal Request','Reversal of Non-renewal',],
    [policyActionConstant.REWRITE]:['Rewrite'],
    [policyActionConstant.CANCELLATION]:['Cancellation Confirmation','Cancellation Request',],

};

export const policyStatusValue = {
    NEW: 'Active',
    REWRITE: 'Rewritten',
    RENEW: 'Renewed',
    CANCELLATION: 'Cancelled',
    ENDORSE: 'Active',   
}

export const confirmationPolicyTypes = ["REW", "RWL", "RIX"];

export const ValidationErrorNameList ={
    BASICPOLICY:'BasicInfoErrorCheckForHighlight',
    INSURED:'InsuredErrorCheckForHighlight',
    COINSURED:'CoInsuredErrorCheckForHighlight',
    COVERAGE:'CoverageErrorCheckForHighlight',
    ENDORSEMENT:'EndorsementErrorCheckForHighlight',
    LOCATION:'LocationErrorCheckForHighlight',
    ADDITIONALINTEREST: 'AdditionalInterestErrorCheckForHighlight',
    FLOODCOVERAGE:'FloodCoverageErrorCheckForHighlight',
    FLOODUNDERWRITING:'FloodUnderwritingErrorCheckForHighlight',
    BASICVEHICLE:'BasicVehicleErrorCheckForHighlight',
}

export const CUSTOMER_ACTIVITY_EXPORT_COLUMNS = {
    POLICY_NUMBER: "Policy Number",
    ACTION_TYPE: "Action Type",
    DATE: "Date",
    TIME: "Time",
    DESCRIPTION: "Description",
    EFFECTIVE_DATE: "Effective Date",
    CSR: "CS2 User"

};

export const CUSTOMER_ACTIVITY_CUSTOM_HEADER_ROWS = {
    CUSTOM_HEADER_NAME: "Customer Name:",
    CUSTOM_HEADER_MAILING_ADDRESS: "Mailing Address:"
};

// Flood Underwriting Validation Constants
export const FloodUnderwritingValidation = {
    REPLACE_COST_RANGE: 'Valid range: 0 to 9,999,999,999.99 (up to 2 decimals)',
    CONDO_NO_OF_UNITS_RANGE: 'Valid range: 1 to 9999 (whole numbers only)',
    BLDG_DIAGRAM_NUM_RANGE: 'Only alphanumeric characters allowed (max 5 characters)',
    DIAGRAM_NUMBER_RANGE: 'Only alphanumeric characters allowed (max 12 characters)',
    LOWEST_ADJ_GRADE_RANGE: 'Valid range: -999.9 to 999.9 (up to 1 decimal)',
    LOWEST_FLOOR_ELEV_RANGE: 'Valid range: -999.9 to 999.9 (up to 1 decimal)',
    BASE_FLOOR_ELEV_RANGE: 'Valid range: -999.9 to 999.9 (up to 1 decimal)',
    ENCLOSED_FLOOR_TYPE_RANGE: 'Valid range: 0 to 9 (whole numbers only)',
    ENCLOSED_SIZE_RANGE: 'Valid range: 0 to 99,999,999 (up to 1 decimal)'
};

// Carrier Management Module Constants
export const CarrierManagementConstants = {
    CARRIER_NAME_LABEL: 'Carrier Name',
    LEGACY_COMPANY_CODE_LABEL: 'Legacy Company Code',
    NAIC_LABEL: 'NAIC',
    FIELD_CANNOT_BE_BLANK: 'Field cannot be blank.',
    ADD_NEW_PARENT_COMPANY_LABEL: 'Add New Parent Company',
    EDIT_LABEL: 'Edit',
    NEW_LABEL: 'New',
    VIEW_LABEL: 'View',
    INSURANCE_COMPANY_HEADER: 'Insurance Companies',
    ADD_PARENT_COMPANY_BUTTON: '+ Add Parent Company',
    OTHER_PARENT_LABEL: 'Other',
    TABS: {
        CARRIER_INFORMATION: { key: 'carrier-information', text: 'Carrier Information' },
        CARRIER_COMMISSION:  { key: 'carrier-commission',  text: 'Carrier Commission'  },
        COMMISSION_HISTORY:  { key: 'commission-history',  text: 'Commission History'  },
        RETENTION_ARRAY:     { key: 'retention-array',     text: 'Retention Array'     },
    },
    RETENTION_ARRAY_TYPES: {
        PREMIUM_DIFFERENCE: '4B26279D-881F-4A4D-9AB3-E273BABE61EA',
        NON_RENEWAL: '18AD61B1-90DD-4D85-AFD2-5A445FBBC77F',
        CANCELLATION: 'CC2734D0-1E16-4C39-BA65-5F03211FF4E5'
    },
    AGENCY_MASTER_CODES: {
        DELETE_CONFIRM: 'Are you sure you want to delete this agency code?',
        CREATED:      'Agency code created successfully.',
        UPDATED:      'Agency code updated successfully.',
        DELETED:      'Agency code deleted successfully.',
        SAVE_ERROR:   'We encountered an issue while saving agency code. Please try again in a moment. If the problem persists, contact support team for assistance.',
        DELETE_ERROR: 'We encountered an issue while deleting agency code. Please try again in a moment. If the problem persists, contact support team for assistance.',
    },
};

export const CUSTOMER_POLICY_LOBCode = {
    FLOOD: "Flood",
    EARTHQUAKE : ["Earthquake (C)", "Earthquake (P)"]
};

export const CUSTOMER_POLICY_LOBCodeId = {
    FLOOD: "7f398f35-5187-42df-a267-470c6464000a",
    EARTHQUAKE: ["22a7ebba-ea41-4cb0-be9f-83bcdf030a4b", "6f00a66e-7de9-467c-9672-e69a3a4061e6"],
    HOMEOWNERS: "be2b23b2-1bae-4c7e-8933-87627dfc89a1",
    PRIVATE_PASSENGER_AUTO: "b8ebc545-75ef-45ac-8ab8-625029e26b68"
};

// LOB IDs that should display 'Property Address' instead of 'Policy Location'
export const PROPERTY_ADDRESS_LOB_IDS = [
    "7f398f35-5187-42df-a267-470c6464000a", // FLOOD
    "22a7ebba-ea41-4cb0-be9f-83bcdf030a4b", // EARTHQUAKE (C)
    "6f00a66e-7de9-467c-9672-e69a3a4061e6", // EARTHQUAKE (P)
    "be2b23b2-1bae-4c7e-8933-87627dfc89a1", // HOMEOWNERS
    "f6afeb34-f929-4289-9ac2-9b3f4e4f0a71"  // WIND
];

export const StatusTypeIds={
    ADD:"022FC2A1-EC80-4CDF-9002-F22FF1F3F291"
}

export const RecurringCampaignErrorMessages = {
    INVALID_END_DATE : 'End Date Invalid.',
    INVALID_START_DATE : 'Start Date Invalid.',
}

export const RECURRING_END_DATE_OPTION = {
  NEVER: 'never',
  ON: 'on'
} as const;

export type RecurringEndDateOption = typeof RECURRING_END_DATE_OPTION[keyof typeof RECURRING_END_DATE_OPTION];

export const SourceTypeID_lookupCode={
    "2f5fc8a3-66b9-4673-a904-7599b9ab0e43":"BP",
    "27a2347c-8cc4-40ce-992b-27a0101ad517":"LP",
    "a86de022-8be9-4d36-afab-1cb691e1c5f4":"OP",
    "8ccf1772-4ded-408c-bd29-11f48b00e661" :"EP"
}

export const EmailDocuments = {
    EMAIL_SENT_SUCCESS: "Email sent successfully.",
    EMAIL_FAILURE:"Error while sending document(s). Please try again.",
    FORM_VALIDATION_ERROR_MESSAGE :"There are few errors in page. Please check the highlighted inputs.",   
    VALIDATION_DOCUMENT_SELECTION: "At least one document should be selected.", 
    VALIDATION_SUBJECTLINE_LIMIT:"Subject line exceeded character limit",
    EMAIL_OUT_ACTIVITY_TYPE: "Email Out",
    ACTIVITY_CREATE_ERROR: "Email sent, but failed to create activity record.",
}

export const CommissionStatementValidation = {
  FILE_INVALID_TYPE: 'Only Excel (.xlsx) files are allowed',
  FILE_SIZE_EXCEEDED: 'File size must not exceed 1GB',
  FILE_REQUIRED: 'Please select a file',
  FORMAT_INCORRECT: 'Incorrect file format',
  IMPORT_FAILED: 'Failed to import the file',
  CONVERT_FAILED: 'Failed to convert the file',
  MIGRATION_FAILED: 'Failed to migrate the file',
}

// Customer Basic Vehicle Form Validation Constants
export const CustomerBasicVehicleValidation = {
  VIN_LENGTH_ERROR: 'VIN must be exactly 17 characters.',
  VEHICLE_YEAR_NUMERIC_ERROR: 'Vehicle Year must be a number.',
  VEHICLE_YEAR_RANGE_ERROR: (currentYear: number) => `Vehicle Year must be between 1900 and ${currentYear + 1}.`,
  PURCHASE_DATE_FORMAT_ERROR: 'Purchase Date format must be MM/YY.',
  PURCHASE_DATE_NUMERIC_ERROR: 'Purchase Date must contain valid numbers.',
  PURCHASE_DATE_MONTH_ERROR: 'Month must be between 01 and 12.',
  PURCHASE_DATE_FUTURE_ERROR: 'Purchase Date cannot be in the future.',
  LEASED_DATE_FORMAT_ERROR: 'Leased Date format must be MM/DD/YYYY.',
  LEASED_DATE_REQUIRED_ERROR: 'Lease Date is required.',
  LEASED_DATE_NUMERIC_ERROR: 'Leased Date must contain valid numbers.',
  LEASED_DATE_DAY_ERROR: 'Day must be between 01 and 31.',
  LEASED_DATE_YEAR_ERROR: 'Year must be a valid 4-digit year (1900 or later).',
  LEASED_DATE_FUTURE_ERROR: 'Leased Date cannot be in the future.',
  COST_NEW_NUMERIC_ERROR: 'Cost New must be a number.',
  COST_NEW_NEGATIVE_ERROR: 'Cost New cannot be negative.',
  VIN_PLACEHOLDER: 'VIN (17 characters)',
  PURCHASE_DATE_PLACEHOLDER: 'MM/YY',
};

// Renovation Year Validation Constants
export const RenovationYearValidation = {
  VALID_YEAR_ERROR: 'Please enter a valid year.',
  WIRING_YEAR_ERROR: 'Wiring Year is required and must be a valid 4-digit year.',
  PLUMBING_YEAR_ERROR: 'Plumbing Year is required and must be a valid 4-digit year.',
  HEATING_YEAR_ERROR: 'Heating Year is required and must be a valid 4-digit year.',
  ROOFING_YEAR_ERROR: 'Roofing Year is required and must be a valid 4-digit year.',
  EXTERIOR_PAINT_YEAR_ERROR: 'Exterior Paint Year must be a valid 4-digit year.',
};

// Customer Vehicle Field Names
export const CustomerVehicleFieldNames = {
  VIN: 'vin',
  REGISTER_STATE: 'registerState',
  VEHICLE_YEAR: 'vehicleYear',
  MAKE: 'make',
  MODEL: 'model',
  BODY_TYPE: 'bodyType',
  IS_LEASED: 'isLeased',
  PURCHASE_DATE: 'purchaseDate',
  COST_NEW: 'costNew',
  LEASED_DATE: 'leasedDate',
};

// Customer Vehicle Table Headers
export const CustomerVehicleTableHeaders = {
  VEHICLE_NUMBER: 'Vehicle Number',
  YEAR: 'Year',
  MAKE: 'Make',
  MODEL: 'Model',
};

export const AdminDocument={
    AdminDocAppId:"110"
}

export const CompensationRateConstants = {
    NO_RECORDS_FOUND: 'No compensation rates found.',
    CREATED: 'Compensation rate created successfully.',
    UPDATED: 'Compensation rate updated successfully.',
    DELETED: 'Compensation rate deleted successfully.',
    SAVE_ERROR: 'We encountered an issue while saving compensation rate. Please try again.',
    DELETE_ERROR: 'We encountered an issue while deleting compensation rate. Please try again.',
    DELETE_CONFIRM: 'Are you sure you want to delete this compensation rate?',
};
export const MovePolicy = {
    ENTER_CS2_ACCOUNT_Number: "Enter CS2 Account Number.",
    POLICY_CANNOT_MOVED:"Policy cannot be moved to the same customer.",
    PLEASE_ENTER_CS2_ACCOUNT_Number :"Please enter a CS2 Account Number.",   
    ACCOUNT_NOT_FOUND: "Account not found.", 
    MOVE_POLICY:"Move Policy",
}

export const AssignmentscreenFilter={
    FILTER: {
        CARRIER: { label: 'Carrier', value: 'carrier' },
        TRANSACTION:  { label: 'Transaction Type', value: 'transactions'  },
        CS2_ENTRY_DATE:  { label: 'CS2 Entry Date', value: 'cs2EntryDate' },
        TRANSACTION_EFFECTIVE_DATE:     {label: 'Transaction Effective Date', value: 'transactionEffectiveDate'},
        TRANSACTION_TERM_DATES:{label: 'Effective Term Dates', value: 'effectiveTermDates'},
        POLICY_NUMBER: { label: 'Policy Number', value: 'policyNumber' },
        ADDRESS: { label: 'Address', value: 'address' },
    },
}
